export default function add([aX, aY], [bX, bY]) {
	return [aX + bX, aY + bY];
}
